import React, { useEffect, useState } from "react";
import FormatUrl from "../../../../../../utils/UrlFormatter";
import '../styles/DisciplineSelector.css'

const DisciplineSelector = ({
  clinicId,
  selectedDiscipline,
  setSelectedDiscipline,
  setSelectedPractitioner,
  setSelectedDate,
}) => {
  const [disciplines, setDisciplines] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchDisciplines = async () => {
      setIsLoading(true);
      try {
        const url = FormatUrl(`/get-clinic-disciplines/?clinic_id=${clinicId}`);
        const res = await fetch(url, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
        });
        const data = await res.json();

        if (data?.status === "Success" && Array.isArray(data?.disciplines)) {
          const formatted = data.disciplines.map((item) => ({
            id: item.name,
            label: item.name,
            ...item,
          }));
          setDisciplines(formatted);
        } else {
          setDisciplines([]);
        }
      } catch {
        setDisciplines([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDisciplines();
  }, [clinicId]);

  const handleChange = (e) => {
    setSelectedDiscipline(e.target.value);
    setSelectedPractitioner(null);
    setSelectedDate(null);
  };

  return (
    <div className="slot-row_manage_slots_settings">
      <label htmlFor="discipline-select" className="slot-label_manage_slots_settings">
        Select Discipline
      </label>
      <select
        id="discipline-select"
        className="slot-dropdown_manage_slots_settings"
        value={selectedDiscipline || ""}
        onChange={handleChange}
        disabled={isLoading}
      >
        <option value="">-- Choose Discipline --</option>
        {disciplines.map((d) => (
          <option key={d.id} value={d.id}>
            {d.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default DisciplineSelector;
